import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable()
export class ConfigurationService {
    getApiBaseUrl(): string{
        return environment.apiBaseUrl;
    }

    getFintFMUrl(): string {
        return environment.fintFMUrl;
    }

    getFintFM2Url(): string {
        return environment.fintFM2Url;
    }
}